export const userManagementDetailsT = {
  title: 'Details',
  errorMessage: 'Something went wrong',

  fields: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'E-mail',
    role: 'Role',
    created: 'Created'
  },

  placeholders: {
    firstName: 'Enter first name',
    lastName: 'Enter last name',
    role: 'Select a role'
  },

  messages: {
    firstName: 'Please enter first name',
    lastName: 'Please enter last name',
    role: 'Please select a role',
    profileUpdated: 'Profile updated',
    unavailableRole: 'Please select a role',
    roleInfo:
      'Includes permission to approve batch and manual payouts subject to approval workflows.',
    unassignableRole:
      'This user currently has a role that is no longer assignable.'
  },
  actions: {
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save changes',
    deactivateUser: 'Deactivate user'
  },

  deactivate: {
    confirmModal: {
      title: 'Deactivate user',
      cancel: 'Cancel',
      confirm: 'Deactivate',
      body: {
        line1Prefix: 'Are you sure you want to deactivate ',
        line2:
          "Deactivation will immediately revoke the user's access to the platform and all associated features.",
        reachOut: 'To reactivate this account in the future, please contact '
      }
    },
    result: {
      successTitle: 'User deactivated',
      successMessageSuffix: 'has been deactivated successfully.',
      errorTitle: 'Unable to deactivate user',
      errorMessage: 'Something went wrong. Please try again.'
    }
  }
} as const;
